import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import OtherFeesTable from './table/product-purchase-other-fee';
import ProductPurchaseTable from './table/product-purchase-table';

export default function ProductCard() {
  const { t } = useTranslation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <Text variant="HeadingXSmall">{t('common:product_details')}</Text>
      <Separator gap={16} />
      <ProductPurchaseTable />
      <Separator gap={16} />
      <OtherFeesTable />
      <Separator gap={16} />
    </CardSection>
  );
}
